import { Component, ChangeDetectionStrategy, inject} from '@angular/core';
import { Router } from '@angular/router';
import { MatButton } from '@angular/material/button';
import { ErrorStateComponent } from '../error-state/error-state.component';

@Component({
    selector: 'gcp-workspace-unauthorized',
    templateUrl: './unauthorized.component.html',
    styleUrl: './unauthorized.component.scss',
    imports: [ErrorStateComponent, MatButton],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UnauthorizedComponent {
  private readonly router = inject(Router);

  goToHome() {
    void this.router.navigate(['/home']);
  }
}
